// extracted by mini-css-extract-plugin
export default {"active":"edit-module__[local]___pMNYl","group":"edit-module__[local]___WjkUc"};